import { useState } from 'react';
import dogIcon from '@assets/images/home-category-dog.svg';
import catIcon from '@assets/images/home-category-cat.svg';
import Dogs from '@pages/home/dogs/Dogs';
import Cats from '@pages/home/cats/Cats';



enum CategoryEnum {
	dogs = 'dogs',
	cats = 'cats',
}



const Home = () => {

	const [ category, setCategory ] = useState(CategoryEnum.dogs);


	return (
		<div className="app-page home-page">
			
			<div className='category-icons'>

				<img src={dogIcon} alt='dog-category-icon'
					className={`category-icon disable-selection ${category === CategoryEnum.dogs ? 'active-category' : ''}`}
					draggable={false}
					onClick={() => setCategory(CategoryEnum.dogs)} />
				
				<img src={catIcon} alt='cat-category-icon'
					className={`category-icon disable-selection ${category === CategoryEnum.cats ? 'active-category' : ''}`}
					draggable={false}
					onClick={() => setCategory(CategoryEnum.cats)} />
			
			</div>

			{category === CategoryEnum.dogs &&
				<Dogs />}

			{category === CategoryEnum.cats &&
				<Cats />}

		</div>
	);
};

export default Home;